import type { AppManifest, EditorSDK, PageSettings } from '@wix/platform-editor-sdk';
import type { TranslationFunction } from 'i18next';

import { buildPanelUrl } from '../../../../services/panel-url-builder';
import { PageName } from './types';

type PageSettingsOptions = NonNullable<AppManifest['pages']>['pageSettings'];

const getPageInfoSettings = async (editorSDK: EditorSDK, pageName: PageName): Promise<PageSettings> => ({
  type: 'page_info',
  title: '',
  url: await buildPanelUrl(editorSDK, 'pageInfoEditor3.html', `?page=${pageName}`),
});

const getPermissionsSettings = (): PageSettings => ({
  type: 'permissions',
  title: '',
});

const getSocialShareSettings = (): PageSettings => ({
  type: 'social_share',
  title: '',
});

const getSeoSettings = (): PageSettings => ({
  type: 'seo',
  title: '',
});

// page_address is not defined in SDK types
const getPageAddressSettings = (): PageSettings =>
  ({
    type: 'page_address',
    title: '',
  } as unknown as PageSettings);

export const getPageSettingsEditor3 = async (
  editorSDK: EditorSDK,
  t: TranslationFunction,
): Promise<PageSettingsOptions> => {
  return {
    default: [],
    [PageName.Profile]: [
      await getPageInfoSettings(editorSDK, PageName.Profile),
      getSeoSettings(),
      getSocialShareSettings(),
      getPermissionsSettings(),
    ],
    [PageName.AccountSettings]: [
      await getPageInfoSettings(editorSDK, PageName.AccountSettings),
      getPageAddressSettings(),
    ],
    [PageName.Standalone]: [],
    [PageName.Custom]: [
      await getPageInfoSettings(editorSDK, PageName.Custom),
      getSeoSettings(),
      getSocialShareSettings(),
      getPermissionsSettings(),
    ],
    lightbox: [],
  };
};
